import type { CSSProperties, ReactNode } from "react";

export type KPIAccent = "neutral" | "positive" | "negative";

export interface KPICardProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  accent?: KPIAccent;
}

const cardStyle: CSSProperties = {
  background: "var(--d-ink-2)",
  border: "1px solid var(--d-line)",
  borderRadius: 22,
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 6,
  minHeight: 96,
};

const labelStyle: CSSProperties = {
  fontFamily: "var(--font-body)",
  fontSize: 11,
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: "var(--d-fg-dim)",
};

function valueStyle(accent: KPIAccent): CSSProperties {
  return {
    fontFamily: "var(--font-mono)",
    fontSize: 22,
    lineHeight: 1.1,
    fontVariantNumeric: "tabular-nums",
    color:
      accent === "positive" ? "var(--d-gold)"
      : accent === "negative" ? "var(--d-ember)"
      : "var(--d-fg)",
  };
}

const hintStyle: CSSProperties = {
  fontFamily: "var(--font-body)",
  fontSize: 12,
  color: "var(--d-fg-muted)",
};

export function KPICard({ label, value, hint, accent = "neutral" }: KPICardProps): JSX.Element {
  return (
    <div style={cardStyle}>
      <div style={labelStyle}>{label}</div>
      <div data-testid="kpi-value" style={valueStyle(accent)}>{value}</div>
      {hint ? <div style={hintStyle}>{hint}</div> : null}
    </div>
  );
}
